import * as z from "zod/v4";
import {
  intentV12_28_2025CoverageMlModel,
  intentV12_28_2025CoverageMlModelDbSchema,
} from "./model/intent-v12_28_2025";
import {
  randomCoverageMlModel,
  randomCoverageMlModelDbSchema,
} from "./model/random";
import {
  stagecoachCoverageMlModel,
  stagecoachCoverageMlModelDbSchema,
} from "./model/stagecoach";
import {
  INTENT_V12_28_2025_COVERAGE_ML_MODEL_ID,
  RANDOM_COVERAGE_ML_MODEL_ID,
  STAGECOACH_COVERAGE_ML_MODEL_ID,
} from "./types";

export const coverageMlModelInferenceRegistry = {
  [RANDOM_COVERAGE_ML_MODEL_ID]: randomCoverageMlModel,
  [INTENT_V12_28_2025_COVERAGE_ML_MODEL_ID]: intentV12_28_2025CoverageMlModel,
  [STAGECOACH_COVERAGE_ML_MODEL_ID]: stagecoachCoverageMlModel,
};

export const coverageMlModelDbSchema = z.union([
  randomCoverageMlModelDbSchema,
  intentV12_28_2025CoverageMlModelDbSchema,
  stagecoachCoverageMlModelDbSchema,
]);
export type CoverageMlModelDb = z.infer<typeof coverageMlModelDbSchema>;
